import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const DISMISS_KEY = "paymentBannerDismissedAt";

export const PaymentStatusBanner = () => {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const dismissedAt = localStorage.getItem(DISMISS_KEY);
    if (dismissedAt && Date.now() - Number(dismissedAt) < 24 * 60 * 60 * 1000) {
      setDismissed(true);
    }
    axios.get(`${API}/parent-communication/payment-status`).then((res) => {
      setStatus({
        paymentStatus: res.data?.paymentStatus,
        inGracePeriod: res.data?.inGracePeriod,
        graceDaysRemaining: res.data?.graceDaysRemaining,
      });
    }).catch(() => {});
  }, []);

  if (dismissed || !status) return null;
  const showRed = status.paymentStatus === "failed" && !status.inGracePeriod;
  const showYellow = status.inGracePeriod;
  if (!showRed && !showYellow) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setDismissed(true);
  };

  return (
    <div
      className={`w-full px-4 py-2.5 text-sm flex items-center justify-between gap-3 ${
        showRed ? "bg-rose-50 border-b border-rose-200 text-rose-800" : "bg-amber-50 border-b border-amber-200 text-amber-900"
      }`}
      data-testid="payment-status-banner"
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        {showRed ? (
          <span><strong>Payment Failed.</strong> Parent portal access is locked. Update your payment method to restore access.</span>
        ) : (
          <span><strong>Payment past due.</strong> {status.graceDaysRemaining} day(s) of grace period left before access locks.</span>
        )}
        <button
          onClick={() => navigate("/settings/parent-communication")}
          className="underline font-semibold hover:opacity-80"
          data-testid="payment-banner-update-btn"
        >
          Update Payment Method →
        </button>
      </div>
      <button onClick={handleDismiss} className="p-1 hover:bg-black/5 rounded" data-testid="payment-banner-dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default PaymentStatusBanner;
